<template>
  <div class="imgsort-list">
    <div class="page-filter">
      <div class="condition-wrap">
        <span class="condition-label">标签</span>
        <el-input class="w200" maxlength="20" style="width:200px;" v-model="tagName" placeholder="请输入标签"></el-input>
      </div>
      <div class="condition-wrap">
        <el-button type="primary" @click="getTagList">筛选</el-button>
      </div>
      <div class="condition-wrap">
        <el-button type="success" @click="btnAdd">新增标签</el-button>
      </div>
    </div>
      <el-table :data="tableData" style="width: 100%" size="middle" border stripe>
        <el-table-column
        type="index"
        label="序号"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column prop="tagName" label="标签名称" align="center"></el-table-column>
      <el-table-column label="使用次数" align="center">
        <template slot-scope="scope">
          {{scope.row.tagCount || 0}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="140">
        <template slot-scope="scope">
          <el-button type="primary" @click="updateTag(scope.row)" v-if="scope.row.status">禁用</el-button>
          <el-button type="danger" @click="updateTag(scope.row)" v-else>启用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="site-page">
      <el-pagination
        background
        :page-count="totalPage"
        :current-page="pageNum"
        @current-change="getTagList"
        layout="prev, pager, next, jumper"
      ></el-pagination>
    </div>
    <el-dialog @close="addForm.tagName=''" title="新增标签" :visible.sync="showAddPop" width="500px">
      <el-form :model="addForm" size="small" label-width="100px">
        <el-form-item label="标签">
          <el-input v-model="addForm.tagName" placeholder="请输入标签"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center;">
        <el-button @click="showAddPop = false">取 消</el-button>
        <el-button type="primary" @click="addTag">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>


<script>
import API from "../lib/API";
export default {
  name: "TagManage",
  data() {
    return {
      tableData: [],
      pageNum: 1,
      totalPage: 0,
      showAddPop: false,
      tagName: '',
      addForm: {
        tagName: '',
        status: 1
      },
    };
  },
  methods: {
    btnAdd() {
      this.showAddPop = true;
    },
    getTagList(val) {
      if (!isNaN(val)) {
        this.pageNum = val;
      } else {
        this.pageNum = 1;
      }
      new API(this).POST({
        url: "/tag/listWithPage",
        params: {
          count: true,
          pageNum: this.pageNum,
          pageSize: 10,
          tagName: this.tagName,
        },
        cb: res => {
          let { pages, result } = res;

          this.totalPage = pages;
          this.tableData = result;
        }
      });
    },
    addTag() {
      let { tagName } = this.addForm;
      if (!tagName) {
        this.$message.error("请填写标签名称~");
        return;
      }
      new API(this).POST({
        url: "/tag/addTag",
        params: this.addForm,
        cb: res => {
          if (res === null) {
            this.addForm.tagName = "";
            this.getTagList();
            this.showAddPop = false;
          }
        }
      });
    },
    updateTag(row) {
      new API(this).POST({
        url: "/tag/updateTag",
        params: {
          tagId: row.tagId,
          status: row.status == 0 ? 1 : 0,
          tagName: row.tagName
        },
        cb: res => {
          if (res === null) {
            this.getTagList(this.pageNum);
          }
        }
      });
    },
  },
  created() {
    this.getTagList()
  }
};
</script>


// WEBPACK FOOTER //
// src/components/TagManage.vue